import { render } from "./registration1.vue?vue&type=template&id=da660e56"
import script from "./registration1.vue?vue&type=script&lang=js"
export * from "./registration1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__